import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { PopinRealisationsClients } from '@components/popin-realisations-clients/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageComponent } from '@shared/components/image';
import { PopinContainerComponent } from '@shared/components/popin-container';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  imports: [PopinContainerComponent, ImageComponent, TitleComponent, SvgComponent, TranslatePipe],
  templateUrl: './popin-realisations-clients.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinRealisationsClientsComponent {
  data = inject(DIALOG_DATA) as PopinRealisationsClients;
  selectedProjectIndex = signal(this.data.selectedProjectIndex);
  selectedProject = computed(() => this.data.projects[this.selectedProjectIndex()]!);
  selectedImageIndex = signal(0);
  selectedImage = computed(() => this.selectedProject().images[this.selectedImageIndex()]!);
  nImages = computed(() => this.selectedProject().images.length);
  private nProjects = this.data.projects.length;

  onMoveToProject(direction: 'prev' | 'next') {
    this.selectedProjectIndex.update((currentIndex) => {
      return (currentIndex + this.nProjects + (direction === 'prev' ? -1 : 1)) % this.nProjects;
    });
    this.selectedImageIndex.set(0);
  }

  onMoveToImage(direction: 'prev' | 'next') {
    const nImages = this.nImages();
    this.selectedImageIndex.update((currentIndex) => {
      return (currentIndex + nImages + (direction === 'prev' ? -1 : 1)) % nImages;
    });
  }
}
